import theme from '@/styles/theme'
import styled from '@emotion/styled'

export const SwitchWrapper = styled.div`
  width: 100%;
  padding-top: 10px;
  padding-left: 10px;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    padding-left: 0;
    margin-top: 6px;
    justify-content: center;
  }
`

export const BaseLabel = styled.div`
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  padding-left: 15px;
  text-transform: uppercase;
  margin-right: 15px;

  @media (max-width: 768px) {
    padding-left: 0;
  }
`

export const Label = styled(BaseLabel)`
  ${props => (props.isChecked ? `color: #1f8e53;` : `color: #f54337;`)}
`

export const Switcher = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 23px;
`

export const Input = styled.input`
  display: none;
  &:focus + span {
    box-shadow: 0 0 1px #2196f3;
  }
`

export const BaseSlider = styled.div`
  position: absolute;
  cursor: pointer;
  height: 14px;
  top: 0;
  left: -7px;
  right: 0;
  bottom: 0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  &:before {
    position: absolute;
    content: '';
    height: 28px;
    width: 28px;
    left: -4px;
    bottom: -6px;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`

export const activeSlider = `
  background-color: rgba(31,143,83,0.7);

  &:before {
    background-color: #1f8e53;
    -webkit-transform: translateX(28px);
    -ms-transform: translateX(28px);
    transform: translateX(28px);
  }
`

export const inactiveSlider = `
  background-color: rgba(252,116,106,0.7);

  &:before{
    background-color: #F54337;
  }
`

export const disabledSlider = `
  background-color: ${theme.ds.ColorBaseGreyLevel2};


  &:before{
    background-color: ${theme.ds.ColorBaseGreyLevel3};
  }
`

export const Slider = styled(BaseSlider)(
  ({ isChecked, isDisabled }) => `
  ${isChecked ? activeSlider : inactiveSlider}
  ${isDisabled && disabledSlider}
`
)
